import ShipmentTypes from './ShipmentTypes';

export const getShipmentListInProgress = (payload) => {
  return { type: ShipmentTypes.GET_SHIPMENT_LIST_PROGRESS, payload };
};

export const getSearchQuoteListInProgress = (payload) => {
  return { type: ShipmentTypes.GET_SEARCH_QUOTE_LIST_PROGRESS, payload };
};

export const getShipmentListInSuccess = (payload) => {
  return { type: ShipmentTypes.GET_SHIPMENT_LIST_SUCCESS, payload };
};

export const getSearchQuoteListInSuccess = (payload) => {
  return { type: ShipmentTypes.GET_SEARCH_QUOTE_LIST_SUCCESS, payload };
};

export const getShipmentListInError = (payload) => {
  return { type: ShipmentTypes.GET_SHIPMENT_LIST_ERROR, payload };
};

export const getSearchQuoteListInError = (payload) => {
  return { type: ShipmentTypes.GET_SEARCH_QUOTE_LIST_ERROR, payload };
};

export const setShipmentList = (payload) => {
  return { type: ShipmentTypes.SET_SHIPMENT_LIST, payload };
};

export const setSearchQuoteList = (payload) => {
  return { type: ShipmentTypes.SET_SEARCH_QUOTE_LIST, payload };
};

export const refreshShipmentListInProgress = (payload) => {
  return { type: ShipmentTypes.REFRESH_SHIPMENT_LIST_PROGRESS, payload };
};
export const refreshShipmentListInSuccess = (payload) => {
  return { type: ShipmentTypes.REFRESH_SHIPMENT_LIST_SUCCESS, payload };
};
export const refreshShipmentListInError = (payload) => {
  return { type: ShipmentTypes.REFRESH_SHIPMENT_LIST_ERROR, payload };
};

export const getShipmentDetailsInProgress = (payload) => {
  return { type: ShipmentTypes.GET_SHIPMENT_DETAILS_PROGRESS, payload };
};

export const getShipmentDetailsInSuccess = (payload) => {
  return { type: ShipmentTypes.GET_SHIPMENT_DETAILS_SUCCESS, payload };
};

export const getShipmentDetailsInError = (payload) => {
  return { type: ShipmentTypes.GET_SHIPMENT_DETAILS_ERROR, payload };
};

export const setShipmentFilters = (payload) => {
  return { type: ShipmentTypes.SET_SHIPMENT_FILTERS, payload };
};
export const setSearchQuoteFilters = (payload) => {
  return { type: ShipmentTypes.SET_SEARCH_QUOTE_FILTERS, payload };
};

export const getShipmentDashboardInProgress = (payload) => {
  return { type: ShipmentTypes.GET_SHIPMENT_DASHBOARD_PROGRESS, payload };
};

export const getShipmentDashboardInSuccess = (payload) => {
  return { type: ShipmentTypes.GET_SHIPMENT_DASHBOARD_SUCCESS, payload };
};

export const getShipmentDashboardInError = (payload) => {
  return { type: ShipmentTypes.GET_SHIPMENT_DASHBOARD_ERROR, payload };
};

export const setShipmentDetails = (payload) => {
  return { type: ShipmentTypes.SET_SHIPMEN_DETAILS, payload };
};

export const setShipmentEditStatus = (payload) => {
  return { type: ShipmentTypes.SET_SHIPMEN_EDIT_STATUS, payload };
};

export const generateShipmentNoInProgress = (payload) => {
  return { type: ShipmentTypes.GENERATE_SHIPMENT_NUMBER_PROGRESS, payload };
};

export const generateShipmentNoInSuccess = (payload) => {
  return { type: ShipmentTypes.GENERATE_SHIPMENT_NUMBER_SUCCESS, payload };
};

export const generateShipmentNoInError = (payload) => {
  return { type: ShipmentTypes.GENERATE_SHIPMENT_NUMBER_ERROR, payload };
};

export const setSelectedShipments = (payload) => {
  return { type: ShipmentTypes.SET_SELECTED_SHIPMENTS, payload };
};

export const deleteShipmentsInProgress = (payload) => {
  return { type: ShipmentTypes.DELETE_SHIPMENTS_PROGRESS, payload };
};

export const copyShipmentInProgress = (payload) => {
  return { type: ShipmentTypes.COPY_SHIPMENTS_PROGRESS, payload };
};

export const copyShipmentInSuccess = (payload) => {
  return { type: ShipmentTypes.COPY_SHIPMENTS_SUCCESS, payload };
};

export const copyShipmentInError = (payload) => {
  return { type: ShipmentTypes.COPY_SHIPMENTS_ERROR, payload };
};

export const consolidateShipmentsInProgress = (payload) => {
  return { type: ShipmentTypes.CONSOLIDATE_SHIPMENTS_PROGRESS, payload };
};

export const consolidateShipmentsInSuccess = (payload) => {
  return { type: ShipmentTypes.CONSOLIDATE_SHIPMENTS_SUCCESS, payload };
};

export const consolidateShipmentsInError = (payload) => {
  return { type: ShipmentTypes.CONSOLIDATE_SHIPMENTS_ERROR, payload };
};

export const createShipmentInProgress = (payload) => {
  return { type: ShipmentTypes.CREATE_SHIPMENT_PROGRESS, payload };
};

export const createShipmentInSuccess = (payload) => {
  return { type: ShipmentTypes.CREATE_SHIPMENT_SUCCESS, payload };
};

export const createShipmentInError = (payload) => {
  return { type: ShipmentTypes.CREATE_SHIPMENT_ERROR, payload };
};

export const shipmentSpotBidInProgress = (payload) => {
  return { type: ShipmentTypes.SHIPMENT_SPOTBID_PROGRESS, payload };
};

export const shipmentSpotBidInSuccess = (payload) => {
  return { type: ShipmentTypes.SHIPMENT_SPOTBID_SUCCESS, payload };
};

export const shipmentSpotBidInError = (payload) => {
  return { type: ShipmentTypes.SHIPMENT_SPOTBID_ERROR, payload };
};

export const shipmentAddBidderInProgress = (payload) => {
  return { type: ShipmentTypes.SHIPMENT_ADD_BIDDER_PROGRESS, payload };
};

export const shipmentAddBidderInSuccess = (payload) => {
  return { type: ShipmentTypes.SHIPMENT_ADD_BIDDER_SUCCESS, payload };
};

export const shipmentAddBidderInError = (payload) => {
  return { type: ShipmentTypes.SHIPMENT_ADD_BIDDER_ERROR, payload };
};

export const getShipmentRateShopListInProgress = (payload) => {
  return { type: ShipmentTypes.GET_RATE_SHOP_LIST_PROGRESS, payload };
};

export const getShipmentRateShopListInSuccess = (payload) => {
  return { type: ShipmentTypes.GET_RATE_SHOP_LIST_SUCCESS, payload };
};

export const getShipmentRateShopListInError = (payload) => {
  return { type: ShipmentTypes.GET_RATE_SHOP_LIST_ERROR, payload };
};
export const resetShipmentRateShopList = (payload) => {
  return {
    type: ShipmentTypes.RESET_RATE_SHOP_LIST,
    payload: payload ? payload : {},
  };
};

export const shipmentEndSpotBidInProgress = (payload) => {
  return { type: ShipmentTypes.END_SPOT_BID_PROGRESS, payload };
};

export const shipmentEndSpotBidInSuccess = (payload) => {
  return { type: ShipmentTypes.END_SPOT_BID_SUCCESS, payload };
};

export const shipmentEndSpotBidInError = (payload) => {
  return { type: ShipmentTypes.END_SPOT_BID_ERROR, payload };
};

export const getShipmentDocumentsListInProgress = (payload) => {
  return { type: ShipmentTypes.GET_DOCUMENTS_PROGRESS, payload };
};

export const getShipmentDocumentsListInSuccess = (payload) => {
  return { type: ShipmentTypes.GET_DOCUMENTS_SUCCESS, payload };
};

export const getShipmentDocumentsListInError = (payload) => {
  return { type: ShipmentTypes.GET_DOCUMENTS_ERROR, payload };
};

export const getShipmentDefaultAccessorialsInProgress = (payload) => {
  return { type: ShipmentTypes.GET_DEFAULT_ACCESSORIALS_PROGRESS, payload };
};

export const getShipmentDefaultAccessorialsInSuccess = (payload) => {
  return { type: ShipmentTypes.GET_DEFAULT_ACCESSORIALS_SUCCESS, payload };
};

export const getShipmentDefaultAccessorialsInError = (payload) => {
  return { type: ShipmentTypes.GET_DEFAULT_ACCESSORIALS_ERROR, payload };
};

export const getShipmentTenderEmailInProgress = (payload) => {
  return { type: ShipmentTypes.GET_TENDER_EMAIL_PROGRESS, payload };
};

export const getShipmentTenderEmailInSuccess = (payload) => {
  return { type: ShipmentTypes.GET_TENDER_EMAIL_SUCCESS, payload };
};

export const getShipmentTenderEmailInError = (payload) => {
  return { type: ShipmentTypes.GET_TENDER_EMAIL_ERROR, payload };
};

export const shipmentTenderProcessInProgress = (payload) => {
  return { type: ShipmentTypes.TENDER_PROCESS_PROGRESS, payload };
};

export const shipmentTenderProcessInSuccess = (payload) => {
  return { type: ShipmentTypes.TENDER_PROCESS_SUCCESS, payload };
};

export const shipmentTenderProcessInError = (payload) => {
  return { type: ShipmentTypes.TENDER_PROCESS_ERROR, payload };
};

export const getShipmentSpotBidDataInProgress = (payload) => {
  return { type: ShipmentTypes.GET_SPOT_BID_DATA_PROGRESS, payload };
};

export const getShipmentSpotBidDataInSuccess = (payload) => {
  return { type: ShipmentTypes.GET_SPOT_BID_DATA_SUCCESS, payload };
};

export const getShipmentSpotBidDataInError = (payload) => {
  return { type: ShipmentTypes.GET_SPOT_BID_DATA_ERROR, payload };
};

export const shipmentPartialSave = (payload) => {
  return { type: ShipmentTypes.SHIPMENT_PARTIAL_SAVE, payload };
};

export const setShipmentData = (payload) => {
  return { type: ShipmentTypes.SET_SHIPMENT_DATA, payload };
};

export const shipmentMileageCalculatorInProgress = (payload) => {
  return { type: ShipmentTypes.MILEAGE_CALCULATOR_PROGRESS, payload };
};

export const shipmentMileageCalculatorInSuccess = (payload) => {
  return { type: ShipmentTypes.MILEAGE_CALCULATOR_SUCCESS, payload };
};

export const shipmentMileageCalculatorInError = (payload) => {
  return { type: ShipmentTypes.MILEAGE_CALCULATOR_ERROR, payload };
};

export const getCustomerRoutingSettingsInProgress = (payload) => {
  return {
    type: ShipmentTypes.GET_CUSTOMER_ROUTINGS_SETTINGS_PROGRESS,
    payload,
  };
};

export const getCustomerRoutingSettingsInSuccess = (payload) => {
  return {
    type: ShipmentTypes.GET_CUSTOMER_ROUTINGS_SETTINGS_SUCCESS,
    payload,
  };
};

export const getCustomerRoutingSettingsInError = (payload) => {
  return { type: ShipmentTypes.GET_CUSTOMER_ROUTINGS_SETTINGS_ERROR, payload };
};

export const setShipmentDetailsActiveTab = (payload) => {
  return { type: ShipmentTypes.SET_SHIPMENT_DETAILS_ACTIVE_TAB, payload };
};

export const saveShipmentAddressBookInProgress = (payload) => {
  return {
    type: ShipmentTypes.SAVE_ADDRESS_BOOK_PROGRESS,
    payload,
  };
};
export const saveShipmentAddressBookInSuccess = (payload) => {
  return {
    type: ShipmentTypes.SAVE_ADDRESS_BOOK_SUCCESS,
    payload,
  };
};
export const saveShipmentAddressBookInError = (payload) => {
  return { type: ShipmentTypes.SAVE_ADDRESS_BOOK_ERROR, payload };
};

export const deleteShipmentAddressBookInProgress = (payload) => {
  return {
    type: ShipmentTypes.DELETE_ADDRESS_BOOK_PROGRESS,
    payload,
  };
};
export const deleteShipmentAddressBookInSuccess = (payload) => {
  return {
    type: ShipmentTypes.DELETE_ADDRESS_BOOK_SUCCESS,
    payload,
  };
};
export const deleteShipmentAddressBookInError = (payload) => {
  return { type: ShipmentTypes.DELETE_ADDRESS_BOOK_ERROR, payload };
};

export const saveShipmentProductInProgress = (payload) => {
  return {
    type: ShipmentTypes.SAVE_PRODUCT_PROGRESS,
    payload,
  };
};

export const saveShipmentProductInSuccess = (payload) => {
  return {
    type: ShipmentTypes.SAVE_PRODUCT_SUCCESS,
    payload,
  };
};

export const saveShipmentProductInError = (payload) => {
  return { type: ShipmentTypes.SAVE_PRODUCT_ERROR, payload };
};

export const getShipmentTrackingDetailsInProgress = (payload) => {
  return {
    type: ShipmentTypes.GET_TRACKING_DETAILS_PROGRESS,
    payload,
  };
};

export const getShipmentTrackingDetailsInSuccess = (payload) => {
  return {
    type: ShipmentTypes.GET_TRACKING_DETAILS_SUCCESS,
    payload,
  };
};

export const getShipmentTrackingDetailsInError = (payload) => {
  return { type: ShipmentTypes.GET_TRACKING_DETAILS_ERROR, payload };
};

export const sendMailShipmentDocumentInProgress = (payload) => {
  return {
    type: ShipmentTypes.SEND_DOCUMENT_MAIL_PROGRESS,
    payload,
  };
};

export const sendMailShipmentDocumentInSuccess = (payload) => {
  return {
    type: ShipmentTypes.SEND_DOCUMENT_MAIL_SUCCESS,
    payload,
  };
};

export const sendMailShipmentDocumentInError = (payload) => {
  return { type: ShipmentTypes.SEND_DOCUMENT_MAIL_ERROR, payload };
};

export const saveShipmentItrackInProgress = (payload) => {
  return {
    type: ShipmentTypes.SAVE_SHIPMENT_ITRACK_PROGRESS,
    payload,
  };
};

export const saveShipmentItrackInSuccess = (payload) => {
  return {
    type: ShipmentTypes.SAVE_SHIPMENT_ITRACK_SUCCESS,
    payload,
  };
};

export const saveShipmentItrackInError = (payload) => {
  return { type: ShipmentTypes.SAVE_SHIPMENT_ITRACK_ERROR, payload };
};

export const getShipmentNotificationRoutingInProgress = (payload) => {
  return {
    type: ShipmentTypes.GET_SHIPMENT_NOTIFICATION_ROUTING_PROGRESS,
    payload,
  };
};

export const getShipmentNotificationRoutingInSuccess = (payload) => {
  return {
    type: ShipmentTypes.GET_SHIPMENT_NOTIFICATION_ROUTING_SUCCESS,
    payload,
  };
};

export const getShipmentNotificationRoutingInError = (payload) => {
  return {
    type: ShipmentTypes.GET_SHIPMENT_NOTIFICATION_ROUTING_ERROR,
    payload,
  };
};

export const getShipmentNotificationDistributionsInProgress = (payload) => {
  return {
    type: ShipmentTypes.GET_SHIPMENT_NOTIFICATION_DISTRIBUTORS_PROGRESS,
    payload,
  };
};

export const getShipmentNotificationDistributionsInSuccess = (payload) => {
  return {
    type: ShipmentTypes.GET_SHIPMENT_NOTIFICATION_DISTRIBUTORS_SUCCESS,
    payload,
  };
};

export const getShipmentNotificationDistributionsInError = (payload) => {
  return {
    type: ShipmentTypes.GET_SHIPMENT_NOTIFICATION_DISTRIBUTORS_ERROR,
    payload,
  };
};

export const saveNotificationDistributionsInProgress = (payload) => {
  return {
    type: ShipmentTypes.SAVE_NOTIFICATION_DISTRIBUTORS_PROGRESS,
    payload,
  };
};
export const saveNotificationDistributionsInSuccess = (payload) => {
  return {
    type: ShipmentTypes.SAVE_NOTIFICATION_DISTRIBUTORS_SUCCESS,
    payload,
  };
};
export const saveNotificationDistributionsInError = (payload) => {
  return {
    type: ShipmentTypes.SAVE_NOTIFICATION_DISTRIBUTORS_ERROR,
    payload,
  };
};

export const deleteNotificationDistributionsInProgress = (payload) => {
  return {
    type: ShipmentTypes.DELETE_NOTIFICATION_DISTRIBUTORS_PROGRESS,
    payload,
  };
};
export const deleteNotificationDistributionsInSuccess = (payload) => {
  return {
    type: ShipmentTypes.DELETE_NOTIFICATION_DISTRIBUTORS_SUCCESS,
    payload,
  };
};
export const deleteNotificationDistributionsInError = (payload) => {
  return {
    type: ShipmentTypes.DELETE_NOTIFICATION_DISTRIBUTORS_ERROR,
    payload,
  };
};

export const saveNotificationRoutingInProgress = (payload) => {
  return {
    type: ShipmentTypes.SAVE_NOTIFICATION_ROUTING_PROGRESS,
    payload,
  };
};
export const saveNotificationRoutingInSuccess = (payload) => {
  return {
    type: ShipmentTypes.SAVE_NOTIFICATION_ROUTING_SUCCESS,
    payload,
  };
};
export const saveNotificationRoutingInError = (payload) => {
  return {
    type: ShipmentTypes.SAVE_NOTIFICATION_ROUTING_ERROR,
    payload,
  };
};

export const deleteNotificationRoutingInProgress = (payload) => {
  return {
    type: ShipmentTypes.DELETE_NOTIFICATION_ROUTING_PROGRESS,
    payload,
  };
};
export const deleteNotificationRoutingInSuccess = (payload) => {
  return {
    type: ShipmentTypes.DELETE_NOTIFICATION_ROUTING_SUCCESS,
    payload,
  };
};
export const deleteNotificationRoutingInError = (payload) => {
  return {
    type: ShipmentTypes.DELETE_NOTIFICATION_ROUTING_ERROR,
    payload,
  };
};

export const setShipmentAddressBookFilter = (payload) => {
  return {
    type: ShipmentTypes.SET_SHIPMENT_ADDRESS_BOOK_FILTER,
    payload,
  };
};

export const searchCustomerAddressBookInProgress = (payload) => {
  return {
    type: ShipmentTypes.SEARCH_CUSTOMER_ADDRESS_BOOK_PROGRESS,
    payload,
  };
};
export const searchCustomerAddressBookInSuccess = (payload) => {
  return {
    type: ShipmentTypes.SEARCH_CUSTOMER_ADDRESS_BOOK_SUCCESS,
    payload,
  };
};
export const updateCustomerAddressBook = (payload) => {
  return {
    type: ShipmentTypes.UPDATE_CUSTOMER_ADDRESS_BOOK,
    payload,
  };
};
export const searchCustomerAddressBookInError = (payload) => {
  return {
    type: ShipmentTypes.SEARCH_CUSTOMER_ADDRESS_BOOK_ERROR,
    payload,
  };
};

export const setCustomerAddressBookInError = (payload) => {
  return {
    type: ShipmentTypes.SET_CUSTOMER_ADDRESS_BOOK,
    payload,
  };
};

export const getShipmentCustomerAccessorialsInProgress = (payload) => {
  return {
    type: ShipmentTypes.GET_SHIPMENT_CUSTOMER_ACCESSORIALS_PROGRESS,
    payload,
  };
};
export const getShipmentCustomerAccessorialsInSuccess = (payload) => {
  return {
    type: ShipmentTypes.GET_SHIPMENT_CUSTOMER_ACCESSORIALS_SUCCESS,
    payload,
  };
};
export const getShipmentCustomerAccessorialsInError = (payload) => {
  return {
    type: ShipmentTypes.GET_SHIPMENT_CUSTOMER_ACCESSORIALS_ERROR,
    payload,
  };
};

export const createShipmentQuoteInProgress = (payload) => {
  return {
    type: ShipmentTypes.CREATE_SHIPMENT_QUOTE_PROGRESS,
    payload,
  };
};
export const createShipmentQuoteInSuccess = (payload) => {
  return {
    type: ShipmentTypes.CREATE_SHIPMENT_QUOTE_SUCCESS,
    payload,
  };
};
export const createShipmentQuoteInError = (payload) => {
  return {
    type: ShipmentTypes.CREATE_SHIPMENT_QUOTE_ERROR,
    payload,
  };
};
export const resetCreateShipmentQuote = () => {
  return {
    type: ShipmentTypes.RESET_CREATE_SHIPMENT_QUOTE,
  };
};

export const saveShipmentAccountingPartialInProgress = (payload) => {
  return {
    type: ShipmentTypes.SAVE_SHIPMENT_ACCOUNTING_PARTIAL_PROGRESS,
    payload,
  };
};
export const saveShipmentAccountingPartialInSuccess = (payload) => {
  return {
    type: ShipmentTypes.SAVE_SHIPMENT_ACCOUNTING_PARTIAL_SUCCESS,
    payload,
  };
};
export const saveShipmentAccountingPartialInError = (payload) => {
  return {
    type: ShipmentTypes.SAVE_SHIPMENT_ACCOUNTING_PARTIAL_ERROR,
    payload,
  };
};

export const createShipmentFromQuoteInProgress = (payload) => {
  return {
    type: ShipmentTypes.CREATE_SHIPMENT_FROM_QUOTE_PROGRESS,
    payload,
  };
};
export const createShipmentFromQuoteInSuccess = (payload) => {
  return {
    type: ShipmentTypes.CREATE_SHIPMENT_FROM_QUOTE_SUCCESS,
    payload,
  };
};
export const createShipmentFromQuoteInError = (payload) => {
  return {
    type: ShipmentTypes.CREATE_SHIPMENT_FROM_QUOTE_ERROR,
    payload,
  };
};

export const getMilageByStopsInProgress = (payload) => {
  return {
    type: ShipmentTypes.GET_MILAGE_BY_STOPS_PROGRESS,
    payload,
  };
};
export const getMilageByStopsInSuccess = (payload) => {
  return {
    type: ShipmentTypes.GET_MILAGE_BY_STOPS_SUCCESS,
    payload,
  };
};
export const getMilageByStopsInError = (payload) => {
  return {
    type: ShipmentTypes.GET_MILAGE_BY_STOPS_ERROR,
    payload,
  };
};

export const getParcelExpressRatesInProgress = (payload) => {
  return {
    type: ShipmentTypes.GET_PARCEL_EXPRESS_RATES_PROGRESS,
    payload,
  };
};
export const getParcelExpressRatesInSuccess = (payload) => {
  return {
    type: ShipmentTypes.GET_PARCEL_EXPRESS_RATES_SUCCESS,
    payload,
  };
};
export const getParcelExpressRatesInError = (payload) => {
  return {
    type: ShipmentTypes.GET_PARCEL_EXPRESS_RATES_ERROR,
    payload,
  };
};

export const createParcelExpressShippingLabelInProgress = (payload) => {
  return {
    type: ShipmentTypes.CREATE_PARCEL_EXPRESS_SHIPPING_LABEL_PROGRESS,
    payload,
  };
};
export const createParcelExpressShippingLabelInSuccess = (payload) => {
  return {
    type: ShipmentTypes.CREATE_PARCEL_EXPRESS_SHIPPING_LABEL_SUCCESS,
    payload,
  };
};
export const createParcelExpressShippingLabelInError = (payload) => {
  return {
    type: ShipmentTypes.CREATE_PARCEL_EXPRESS_SHIPPING_LABEL_ERROR,
    payload,
  };
};
export const resetCreateParcelExpressShippingLabel = () => {
  return {
    type: ShipmentTypes.RESET_CREATE_PARCEL_EXPRESS_SHIPPING_LABEL,
  };
};

export const generateApprovalNumberInProgress = (payload) => {
  return {
    type: ShipmentTypes.GENERATE_APPROVAL_NUMBER_PROGRESS,
    payload,
  };
};
export const generateApprovalNumberInSuccess = (payload) => {
  return {
    type: ShipmentTypes.GENERATE_APPROVAL_NUMBER_SUCCESS,
    payload,
  };
};
export const generateApprovalNumberInError = (payload) => {
  return {
    type: ShipmentTypes.GENERATE_APPROVAL_NUMBER_ERROR,
    payload,
  };
};

export const validateAndGetApproversListInProgress = (payload) => {
  return {
    type: ShipmentTypes.VALIDATE_AND_GET_APPROVERS_LIST_PROGRESS,
    payload,
  };
};
export const validateAndGetApproversListInSuccess = (payload) => {
  return {
    type: ShipmentTypes.VALIDATE_AND_GET_APPROVERS_LIST_SUCCESS,
    payload,
  };
};
export const validateAndGetApproversListInError = (payload) => {
  return {
    type: ShipmentTypes.VALIDATE_AND_GET_APPROVERS_LIST_ERROR,
    payload,
  };
};

export const createChildShipmentInProgress = (payload) => {
  return {
    type: ShipmentTypes.CREATE_CHILD_SHIPMENT_PROGRESS,
    payload,
  };
};
export const createChildShipmentInSuccess = (payload) => {
  return {
    type: ShipmentTypes.CREATE_CHILD_SHIPMENT_SUCCESS,
    payload,
  };
};
export const createChildShipmentInError = (payload) => {
  return {
    type: ShipmentTypes.CREATE_CHILD_SHIPMENT_ERROR,
    payload,
  };
};

export const sendShipmentApprovalRequestInProgress = (payload) => {
  return {
    type: ShipmentTypes.SEND_APPROVAL_REQUEST_PROGRESS,
    payload,
  };
};
export const sendShipmentApprovalRequestInSuccess = (payload) => {
  return {
    type: ShipmentTypes.SEND_APPROVAL_REQUEST_SUCCESS,
    payload,
  };
};
export const sendShipmentApprovalRequestInError = (payload) => {
  return {
    type: ShipmentTypes.SEND_APPROVAL_REQUEST_ERROR,
    payload,
  };
};

export const setShipmentApproversList = (payload) => {
  return {
    type: ShipmentTypes.SET_APPROVERS_LIST,
    payload,
  };
};

export const setDocumentListUpload = (payload) => {
  return {
    type: ShipmentTypes.DOCUMENT_UPLOAD_LIST,
    payload,
  };
};

export const setShipmentByKey = (payload) => {
  return {
    type: ShipmentTypes.SET_SHIPMENT_BY_KEY,
    payload,
  };
};

export const shipmentAssignCarrierInProgress = (payload) => {
  return {
    type: ShipmentTypes.ASSIGN_CARRIER_PROGRESS,
    payload,
  };
};
export const shipmentAssignCarrierInSuccess = (payload) => {
  return {
    type: ShipmentTypes.ASSIGN_CARRIER_SUCCESS,
    payload,
  };
};
export const shipmentAssignCarrierInError = (payload) => {
  return {
    type: ShipmentTypes.ASSIGN_CARRIER_ERROR,
    payload,
  };
};

export const addShipmentRateEntryInProgress = (payload) => {
  return {
    type: ShipmentTypes.ADD_RATE_ENTRY_PROGRESS,
    payload,
  };
};
export const addShipmentRateEntryInSuccess = (payload) => {
  return {
    type: ShipmentTypes.ADD_RATE_ENTRY_SUCCESS,
    payload,
  };
};
export const addShipmentRateEntryInError = (payload) => {
  return {
    type: ShipmentTypes.ADD_RATE_ENTRY_ERROR,
    payload,
  };
};

export const validateShipmentRateEntryInProgress = (payload) => {
  return {
    type: ShipmentTypes.VALIDATE_RATE_ENTRY_PROGRESS,
    payload,
  };
};
export const validateShipmentRateEntryInSuccess = (payload) => {
  return {
    type: ShipmentTypes.VALIDATE_RATE_ENTRY_SUCCESS,
    payload,
  };
};
export const validateShipmentRateEntryInError = (payload) => {
  return {
    type: ShipmentTypes.VALIDATE_RATE_ENTRY_ERROR,
    payload,
  };
};

export const removeShipmentRateEntryInProgress = (payload) => {
  return {
    type: ShipmentTypes.REMOVE_RATE_ENTRY_PROGRESS,
    payload,
  };
};
export const removeShipmentRateEntryInSuccess = (payload) => {
  return {
    type: ShipmentTypes.REMOVE_RATE_ENTRY_SUCCESS,
    payload,
  };
};
export const removeShipmentRateEntryInError = (payload) => {
  return {
    type: ShipmentTypes.REMOVE_RATE_ENTRY_ERROR,
    payload,
  };
};

export const getMasterChildShipmentDetailsInProgress = (payload) => {
  return {
    type: ShipmentTypes.GET_MASTER_CHILD_SHIPMENT_DETAILS_PROGRESS,
    payload,
  };
};
export const getMasterChildShipmentDetailsInSuccess = (payload) => {
  return {
    type: ShipmentTypes.GET_MASTER_CHILD_SHIPMENT_DETAILS_SUCCESS,
    payload,
  };
};
export const getMasterChildShipmentDetailsInError = (payload) => {
  return {
    type: ShipmentTypes.GET_MASTER_CHILD_SHIPMENT_DETAILS_ERROR,
    payload,
  };
};

export const updateShipmentRateEntryInProgress = (payload) => {
  return {
    type: ShipmentTypes.UPDATE_RATE_ENTRY_PROGRESS,
    payload,
  };
};
export const updateShipmentRateEntryInSuccess = (payload) => {
  return {
    type: ShipmentTypes.UPDATE_RATE_ENTRY_SUCCESS,
    payload,
  };
};
export const updateShipmentRateEntryInError = (payload) => {
  return {
    type: ShipmentTypes.UPDATE_RATE_ENTRY_ERROR,
    payload,
  };
};

export const convertPartialToShipmentInProgress = (payload) => {
  return {
    type: ShipmentTypes.CONVERT_PARTIAL_TO_SHIPMENT_PROGRESS,
    payload,
  };
};
export const convertPartialToShipmentInSuccess = (payload) => {
  return {
    type: ShipmentTypes.CONVERT_PARTIAL_TO_SHIPMENT_SUCCESS,
    payload,
  };
};
export const convertPartialToShipmentInError = (payload) => {
  return {
    type: ShipmentTypes.CONVERT_PARTIAL_TO_SHIPMENT_ERROR,
    payload,
  };
};

export const getShipmentBranchAddressInProgress = (payload) => {
  return {
    type: ShipmentTypes.GET_SHIPMENT_BRANCH_ADDRESS_PROGRESS,
    payload,
  };
};
export const getShipmentBranchAddressInSuccess = (payload) => {
  return {
    type: ShipmentTypes.GET_SHIPMENT_BRANCH_ADDRESS_SUCCESS,
    payload,
  };
};
export const getShipmentBranchAddressInError = (payload) => {
  return {
    type: ShipmentTypes.GET_SHIPMENT_BRANCH_ADDRESS_ERROR,
    payload,
  };
};

export const getShipmentsStopsInProgress = (payload) => {
  return {
    type: ShipmentTypes.GET_SHIPMENTS_STOPS_PROGRESS,
    payload,
  };
};
export const getShipmentsStopsInSuccess = (payload) => {
  return {
    type: ShipmentTypes.GET_SHIPMENTS_STOPS_SUCCESS,
    payload,
  };
};
export const getShipmentsStopsInError = (payload) => {
  return {
    type: ShipmentTypes.GET_SHIPMENTS_STOPS_ERROR,
    payload,
  };
};

export const getParcelExpressDashboardDataInProgress = (payload) => {
  return {
    type: ShipmentTypes.GET_PARCEL_EXPRESS_DASHBOARD_DATA_PROGRESS,
    payload,
  };
};
export const getParcelExpressDashboardDataInSuccess = (payload) => {
  return {
    type: ShipmentTypes.GET_PARCEL_EXPRESS_DASHBOARD_DATA_SUCCESS,
    payload,
  };
};
export const getParcelExpressDashboardDataInError = (payload) => {
  return {
    type: ShipmentTypes.GET_PARCEL_EXPRESS_DASHBOARD_DATA_ERROR,
    payload,
  };
};

export const setSearchViewTypeType = (payload) => {
  return {
    type: ShipmentTypes.SET_SHIPMENT_SEARCH_VIEW_TYPE,
    payload,
  };
};

export const setSearchViewTypeTypeInitial = (payload) => {
  return {
    type: ShipmentTypes.SET_SHIPMENT_SEARCH_VIEW_TYPE_INITIAL,
    payload,
  };
};

export const setShipmentProductViewType = (payload) => {
  return {
    type: ShipmentTypes.SET_SHIPMENT_PRODUCT_VIEW_TYPE,
    payload,
  };
};

export const setShipmentProductViewTypeInitial = (payload) => {
  return {
    type: ShipmentTypes.SET_SHIPMENT_PRODUCT_VIEW_TYPE_INITIAL,
    payload,
  };
};

export const getShipmentTableViewColumnsInProgress = (payload) => {
  return {
    type: ShipmentTypes.GET_TABLE_VIEW_COLUMNS_PROGRESS,
    payload,
  };
};
export const getShipmentTableViewColumnsInSuccess = (payload) => {
  return {
    type: ShipmentTypes.GET_TABLE_VIEW_COLUMNS_SUCCESS,
    payload,
  };
};
export const getShipmentTableViewColumnsInError = (payload) => {
  return {
    type: ShipmentTypes.GET_TABLE_VIEW_COLUMNS_ERROR,
    payload,
  };
};

export const saveShipmentTableViewColumnsInProgress = (payload) => {
  return {
    type: ShipmentTypes.SAVE_TABLE_VIEW_COLUMNS_PROGRESS,
    payload,
  };
};
export const saveShipmentTableViewColumnsInSuccess = (payload) => {
  return {
    type: ShipmentTypes.SAVE_TABLE_VIEW_COLUMNS_SUCCESS,
    payload,
  };
};
export const saveShipmentTableViewColumnsInError = (payload) => {
  return {
    type: ShipmentTypes.SAVE_TABLE_VIEW_COLUMNS_ERROR,
    payload,
  };
};

export const getShipmentProductListInProgress = (payload) => {
  return {
    type: ShipmentTypes.GET_SHIPMENT_PRODUCT_LIST_PROGRESS,
    payload,
  };
};
export const getShipmentProductListInSuccess = (payload) => {
  return {
    type: ShipmentTypes.GET_SHIPMENT_PRODUCT_LIST_SUCCESS,
    payload,
  };
};
export const getShipmentProductListInError = (payload) => {
  return {
    type: ShipmentTypes.GET_SHIPMENT_PRODUCT_LIST_ERROR,
    payload,
  };
};

export const getShipmentProductFullListInProgress = (payload) => {
  return {
    type: ShipmentTypes.GET_SHIPMENT_PRODUCT_FULL_LIST_PROGRESS,
    payload,
  };
};
export const getShipmentProductFullListInSuccess = (payload) => {
  return {
    type: ShipmentTypes.GET_SHIPMENT_PRODUCT_FULL_LIST_SUCCESS,
    payload,
  };
};
export const getShipmentProductFullListInError = (payload) => {
  return {
    type: ShipmentTypes.GET_SHIPMENT_PRODUCT_FULL_LIST_ERROR,
    payload,
  };
};

export const updateShipmentProductListPartialInProgress = (payload) => {
  return {
    type: ShipmentTypes.UPDATE_PRODUCT_LIST_PARTIAL_PROGRESS,
    payload,
  };
};
export const updateShipmentProductListPartialInSuccess = (payload) => {
  return {
    type: ShipmentTypes.UPDATE_PRODUCT_LIST_PARTIAL_SUCCESS,
    payload,
  };
};
export const updateShipmentProductListPartialInError = (payload) => {
  return {
    type: ShipmentTypes.UPDATE_PRODUCT_LIST_PARTIAL_ERROR,
    payload,
  };
};

export const updateShipmentProductFreightClassInProgress = (payload) => {
  return {
    type: ShipmentTypes.UPDATE_FREIGHT_CLASS_PROGRESS,
    payload,
  };
};
export const updateShipmentProductFreightClassInSuccess = (payload) => {
  return {
    type: ShipmentTypes.UPDATE_FREIGHT_CLASS_SUCCESS,
    payload,
  };
};
export const updateShipmentProductFreightClassInError = (payload) => {
  return {
    type: ShipmentTypes.UPDATE_FREIGHT_CLASS_ERROR,
    payload,
  };
};

export const updateShipmentSingleProductByIndex = (payload) => {
  return {
    type: ShipmentTypes.UPDATE_SINGLE_PRODUCT_BY_INDEX,
    payload,
  };
};

export const updateShipmentBOLCarrierInProgress = (payload) => {
  return {
    type: ShipmentTypes.UPDATE_BOL_CARRIER_PROGRESS,
    payload,
  };
};
export const updateShipmentBOLCarrierInSuccess = (payload) => {
  return {
    type: ShipmentTypes.UPDATE_BOL_CARRIER_SUCCESS,
    payload,
  };
};
export const updateShipmentBOLCarrierInError = (payload) => {
  return {
    type: ShipmentTypes.UPDATE_BOL_CARRIER_ERROR,
    payload,
  };
};

export const getShipmentAdvancedPlanningNoticeEmailsInProgress = (payload) => {
  return {
    type: ShipmentTypes.GET_ADVANCED_PLANNING_EMAILS_PROGRESS,
    payload,
  };
};
export const getShipmentAdvancedPlanningNoticeEmailsInSuccess = (payload) => {
  return {
    type: ShipmentTypes.GET_ADVANCED_PLANNING_EMAILS_SUCCESS,
    payload,
  };
};
export const getShipmentAdvancedPlanningNoticeEmailsInError = (payload) => {
  return {
    type: ShipmentTypes.GET_ADVANCED_PLANNING_EMAILS_ERROR,
    payload,
  };
};

export const sendShipmentAdvancedPlanningNoticeEmailInProgress = (payload) => {
  return {
    type: ShipmentTypes.SEND_ADVANCED_PLANNING_EMAIL_PROGRESS,
    payload,
  };
};
export const sendShipmentAdvancedPlanningNoticeEmailInSuccess = (payload) => {
  return {
    type: ShipmentTypes.SEND_ADVANCED_PLANNING_EMAIL_SUCCESS,
    payload,
  };
};
export const sendShipmentAdvancedPlanningNoticeEmailInError = (payload) => {
  return {
    type: ShipmentTypes.SEND_ADVANCED_PLANNING_EMAIL_ERROR,
    payload,
  };
};

export const resetShipmentEditDetails = () => {
  return {
    type: ShipmentTypes.RESET_SHIPMENT_EDIT_DETAILS,
  };
};

export const setPOtableColumnListActions = (payload) => {
  return {
    type: ShipmentTypes.SET_PO_TABLE_COLUMN,
    payload,
  };
};

export const setShipmentEditRateShopModal = (payload) => {
  return {
    type: ShipmentTypes.SET_EDIT_SHIPMENT_RATESHOP_MODAL,
    payload,
  };
};

export const setShipmentSelectedRateShopIndex = (payload) => {
  return {
    type: ShipmentTypes.SET_SELECTED_RATE_SHOP_INDEX,
    payload,
  };
};

export const setShipmentVendorDataHandler = (payload) => {
  return {
    type: ShipmentTypes.SET_SHIPMENT_VENDOR_DATA,
    payload,
  };
};

export const refreshShipmentDetails = (payload) => {
  return {
    type: ShipmentTypes.REFRESH_SHIPMENT_DETAILS,
    payload,
  };
};

export const setBranchAccNo = (payload) => {
  return {
    type: ShipmentTypes.SET_BRANCH_ACC_NUMBER,
    payload,
  };
};

// todo refactor it (SPOT QUOTE STATE)

export const getSpotQuoteBiddersProgress = (payload) => {
  return {
    type: ShipmentTypes.GET_SPOT_QUOTE_BIDDERS_PROGRESS,
    payload,
  };
};

export const getSpotQuoteBiddersSuccess = (payload) => {
  return {
    type: ShipmentTypes.GET_SPOT_QUOTE_BIDDERS_SUCCESS,
    payload,
  };
};

export const getSpotQuoteBiddersError = (payload) => {
  return {
    type: ShipmentTypes.GET_SPOT_QUOTE_BIDDERS_ERROR,
    payload,
  };
};

export const searchSpotQuoteBiddersProgress = (payload) => {
  return {
    type: ShipmentTypes.SEARCH_SPOT_QUOTE_BIDDERS_PROGRESS,
    payload,
  };
};

export const searchSpotQuoteBiddersSuccess = (payload) => {
  return {
    type: ShipmentTypes.SEARCH_SPOT_QUOTE_BIDDERS_SUCCESS,
    payload,
  };
};

export const searchSpotQuoteBiddersError = (payload) => {
  return {
    type: ShipmentTypes.SEARCH_SPOT_QUOTE_BIDDERS_ERROR,
    payload,
  };
};

export const resetSearchSpotQuoteBidders = (payload) => {
  return {
    type: ShipmentTypes.RESET_SEARCH_QUOTE_BIDDERS,
    payload,
  };
};

export const addSpotQuoteBiddersProgress = (payload) => {
  return {
    type: ShipmentTypes.ADD_SPOT_QUOTE_BIDDERS_PROGRESS,
    payload,
  };
};

export const addSpotQuoteBiddersSuccess = (payload) => {
  return {
    type: ShipmentTypes.ADD_SPOT_QUOTE_BIDDERS_SUCCESS,
    payload,
  };
};

export const addSpotQuoteBiddersError = (payload) => {
  return {
    type: ShipmentTypes.ADD_SPOT_QUOTE_BIDDERS_ERROR,
    payload,
  };
};

export const deleteSpotQuoteBiddersProgress = (payload) => {
  return {
    type: ShipmentTypes.DELETE_SPOT_QUOTE_BIDDERS_PROGRESS,
    payload,
  };
};

export const getSpotQuoteCollaboratorsProgress = (payload) => {
  return {
    type: ShipmentTypes.GET_SPOT_QUOTE_COLLABORATORS_PROGRESS,
    payload,
  };
};

export const getSpotQuoteCollaboratorsSuccess = (payload) => {
  return {
    type: ShipmentTypes.GET_SPOT_QUOTE_COLLABORATORS_SUCCESS,
    payload,
  };
};

export const getSpotQuoteCollaboratorsError = (payload) => {
  return {
    type: ShipmentTypes.GET_SPOT_QUOTE_COLLABORATORS_ERROR,
    payload,
  };
};

export const addSpotQuoteCollaboratorsProgress = (payload) => {
  return {
    type: ShipmentTypes.ADD_SPOT_QUOTE_COLLABORATORS_PROGRESS,
    payload,
  };
};

export const addSpotQuoteCollaboratorsSuccess = (payload) => {
  return {
    type: ShipmentTypes.ADD_SPOT_QUOTE_COLLABORATORS_SUCCESS,
    payload,
  };
};

export const addSpotQuoteCollaboratorsError = (payload) => {
  return {
    type: ShipmentTypes.ADD_SPOT_QUOTE_COLLABORATORS_ERROR,
    payload,
  };
};

export const deleteSpotQuoteCollaboratorsProgress = (payload) => {
  return {
    type: ShipmentTypes.DELETE_SPOT_QUOTE_COLLABORATORS_PROGRESS,
    payload,
  };
};

export const deleteSpotQuoteCollaboratorsSuccess = (payload) => {
  return {
    type: ShipmentTypes.DELETE_SPOT_QUOTE_COLLABORATORS_SUCCESS,
    payload,
  };
};

export const deleteSpotQuoteCollaboratorsError = (payload) => {
  return {
    type: ShipmentTypes.DELETE_SPOT_QUOTE_COLLABORATORS_ERROR,
    payload,
  };
};

export const awardBid = (payload) => {
  return {
    type: ShipmentTypes.AWARD_BID,
    payload,
  };
};

export const deleteSpotQuoteBiddersSuccess = (payload) => {
  return {
    type: ShipmentTypes.DELETE_SPOT_QUOTE_BIDDERS_SUCCESS,
    payload,
  };
};

export const deleteSpotQuoteBiddersError = (payload) => {
  return {
    type: ShipmentTypes.DELETE_SPOT_QUOTE_BIDDERS_ERROR,
    payload,
  };
};

export const awardSpotQuoteBiddersProgress = (payload) => {
  return {
    type: ShipmentTypes.AWARD_SPOT_QUOTE_BIDDERS_PROGRESS,
    payload,
  };
};

export const awardSpotQuoteBiddersSuccess = (payload) => {
  return {
    type: ShipmentTypes.AWARD_SPOT_QUOTE_BIDDERS_SUCCESS,
    payload,
  };
};

export const awardSpotQuoteBiddersError = (payload) => {
  return {
    type: ShipmentTypes.AWARD_SPOT_QUOTE_BIDDERS_ERROR,
    payload,
  };
};

export const clearShipmentDetails = () => {
  return { type: ShipmentTypes.CLEAR_SHIPMENT_DETAILS };
};

export const deleteShipmentTenderProcessInProgress = (payload) => {
  return {
    type: ShipmentTypes.DELETE_SHIPMENT_TENDER_PROGRESS,
    payload,
  };
};
export const deleteShipmentTenderProcessInSuccess = (payload) => {
  return {
    type: ShipmentTypes.DELETE_SHIPMENT_TENDER_SUCCESS,
    payload,
  };
};
export const deleteShipmentTenderProcessInError = (payload) => {
  return {
    type: ShipmentTypes.DELETE_SHIPMENT_TENDER_ERROR,
    payload,
  };
};

export const getCargoSpecificShipmentAccessorialsInProgress = (payload) => {
  return {
    type: ShipmentTypes.GET_CARGO_SPECIFIC_ACCESSORIALS_PROGRESS,
    payload,
  };
};
export const getCargoSpecificShipmentAccessorialsInSuccess = (payload) => {
  return {
    type: ShipmentTypes.GET_CARGO_SPECIFIC_ACCESSORIALS_SUCCESS,
    payload,
  };
};
export const getCargoSpecificShipmentAccessorialsInError = (payload) => {
  return {
    type: ShipmentTypes.GET_CARGO_SPECIFIC_ACCESSORIALS_ERROR,
    payload,
  };
};
